import Api from './index'

export interface ILogin {
    company_name:string
}

export const loginApi = (data:ILogin) => Api.POST({ url: "/v1/company_login/login",data });